import { Meta } from "@/shared/components";
import { StreamEntrypoints } from "@/admin/features/streamEntrypoints";

/**
 * Страница реестра точек входа
 */
export function StreamEntrypointsPage() {
  return (
    <>
      <Meta title="Точки входа" />
      <StreamEntrypoints />
    </>
  );
}
